var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-top-nav"},[_c('a-tabs',{attrs:{"type":"card","defaultActiveKey":_vm.activeType}},_vm._l((_vm.typesMap.type),function(item){return _c('a-tab-pane',{key:item.value,attrs:{"tab":item.label}},[(item.value === 0)?_c('CarRiskList'):_vm._e(),(item.value === 1)?_c('DeviceRiskList'):_vm._e()],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }